"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16PeopleGroupFill = function Svg16PeopleGroupFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 8.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M16 17.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 4 17.5c.017-.282.046-.557.115-.833.108-.43.321-.999.747-1.567C5.766 13.895 7.384 13 10 13s4.234.895 5.137 2.1c.426.568.64 1.137.748 1.567 0 0 .123.478.115.833z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 18a1.5 1.5 0 0 0 1.5-1.5c-.005-.727-.337-1.449-.809-1.988C18.885 13.592 17.537 13 15.5 13c-.154 0-.305.003-.451.01 1.442 1.006 2.446 2.508 2.45 4.486 0 .172-.014.34-.041.504H19zM13.948 11.568a3 3 0 1 0 .49-5.374c.359.69.562 1.474.562 2.306a4.979 4.979 0 0 1-1.052 3.068z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16PeopleGroupFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16PeopleGroupFill;
exports.default = _default;